import { useCallback, useMemo } from "react"
import { useAuthStore } from "@/features/auth/model/store"
import { filterAllowedRoutes } from "@/shared/lib/helper-functions.ts"
import type { CustomRoute } from "@/shared/types"

export function useAllowedRoutes(routes: CustomRoute[]): CustomRoute[] {
  const { me } = useAuthStore()

  const filterFn = useCallback(
    (route: CustomRoute) => {
      return me ? filterAllowedRoutes(route, me) : route
    },
    [me]
  )

  return useMemo(() => routes.map(filterFn).filter(Boolean) as CustomRoute[], [filterFn])
}
